module.exports = __webpack_public_path__ + "static/media/Angelika_Morongova.ba4ae7ba.jpg";